// Small shared time-formatting helpers for "last update" indicators.
import { t } from '../ui/lang';
import { esc } from '../ui/modal';
/** Local wall-clock HH:MM:SS for an ms-epoch timestamp. */
export function formatClock(ts) {
    return new Date(ts).toLocaleTimeString([], { hour12: false });
}
/** Compact age like "5s", "3m", "2h", "4d" relative to now. */
export function formatAge(ts, now = Date.now()) {
    const sec = Math.max(0, Math.round((now - ts) / 1000));
    if (sec < 60)
        return t('nav.age_seconds', { n: sec });
    const min = Math.floor(sec / 60);
    if (min < 60)
        return t('nav.age_minutes', { n: min });
    const hr = Math.floor(min / 60);
    if (hr < 24)
        return t('nav.age_hours', { n: hr });
    return t('nav.age_days', { n: Math.floor(hr / 24) });
}
/** Inline clock SVG used by the "last update" indicators (12×12, stroked). */
export const clockIconSvg = '<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="8" cy="8" r="6.25"/><path d="M8 4.5V8l2.5 1.5"/></svg>';
/**
 * The device card's header clock — ONE implementation for every grid (relay, duo,
 * geelark), so they read the same and change together.
 *
 * `ts` is when the device was last seen ONLINE, not when we last polled it: an offline
 * phone's clock must stop at the moment it dropped instead of ticking with each request.
 * Renders a hidden span when nothing has been seen yet, so nothing shifts once it arrives.
 */
export function lastSeenIndicatorHtml(ts, extraClass = '') {
    const cls = `device-updated${extraClass ? ` ${extraClass}` : ''}`;
    const attrs = ts
        ? ` title="${t('devices.last_online', { time: esc(new Date(ts).toLocaleString()) })}"`
        : ' style="display:none"';
    return `<span class="${cls}"${attrs}>${clockIconSvg}<span class="device-updated__time">${ts ? esc(formatClock(ts)) : ''}</span></span>`;
}
